import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HeroSection from "./components/HeroSection";
import FocusArea from "./components/FocusArea";
import Technologies from "./components/Technologies";

import StatsBar from "./components/StatsBar";
import Industries from "./components/Industries";
import Footer from "./components/Footer";
import Product from "./components/Product";
import ContactUs from "./pages/ContactUs"; // Create this component
// import Navbar from "./components/Navbar"; // Optional if you want navigation
import AboutUs from "./pages/AboutUs";
import DetailsIndustries from './pages/DetailsIndustries';
import FaqSection from './components/FaqSection';
import Testimonials from './components/Testimonials';
import ContactForm from "./pages/ContactForm"; 
import Services from "./pages/Services";
import Blogs from "./pages/Blogs";
import PortfolioSection from "./pages/PortfolioSection";
//import ChatBotWidget from "./components/ChatBotWidget";



const HomePage = () => (
  <>
    <HeroSection />
    <FocusArea />
    <Technologies />
    {/* <Industries /> */}
    <Testimonials/>
    {/* <SuccessStories /> */}
    <StatsBar />
    
    <FaqSection />
    <ContactForm/>
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      {/* Optional Navbar */}
      {/* <Navbar /> */}
      {/* <ChatBotWidget /> */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/product" element={<Product />} />
        {/* <Route path="/detailsindustries" element={<DetailsIndustries />} /> */}
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<Blogs />} />   
        <Route path="/portfoliosection" element={<PortfolioSection />} />   
      </Routes>
    </Router>
  );
}

export default App;
